export const VER_LISTADO_USUARIOS = 29;
export const CREAR_NUEVO_USUARIO = 30;
export const BALANCES_GENERALES = 31;

export const VER_CONTABLE = 33;
export const VER_COMERCIAL = 32;

export const VER_MODULO_SERCLI = [
    VER_LISTADO_USUARIOS,
    CREAR_NUEVO_USUARIO
];
